"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const zod_1 = require("zod");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const FormLabel_1 = require("../../../../material-ui-theme/components/styled/FormLabel");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const query_keys_1 = require("../../../../queries/query-keys");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const purchaseRequestForm_1 = require("../../request/newRequest/purchaseRequestForm");
const approvalsHeader_1 = require("../approvalsHeader");
dayjs_1.default.extend(utc_1.default);
const lexico = new lexico_1.default();
const logger = (0, pino_1.default)();
const StateSchema = zod_1.z.object({
    startOnValue: zod_1.z.union([zod_1.z.custom(val => val instanceof dayjs_1.default, 'Invalid date'), zod_1.z.string()]),
    endOnValue: zod_1.z.union([zod_1.z.custom(val => val instanceof dayjs_1.default, 'Invalid date'), zod_1.z.string()]),
    selectedApproverUserId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    isOutOfOfficeEnabled: zod_1.z.boolean(),
    isValidDate: zod_1.z.boolean(),
    isPastDate: zod_1.z.boolean(),
});
const startDate = (0, dayjs_1.default)();
const endDate = (0, dayjs_1.default)().add(1, 'day');
const initialState = {
    startOnValue: startDate,
    endOnValue: endDate,
    isValidDate: true,
    selectedApproverUserId: '',
    isOutOfOfficeEnabled: false,
    isPastDate: false,
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_START_ON_VALUE': {
            return { ...state, startOnValue: action.payload };
        }
        case 'SET_END_ON_VALUE': {
            return { ...state, endOnValue: action.payload };
        }
        case 'SET_SELECTED_APPROVER_USERID': {
            return { ...state, selectedApproverUserId: action.payload };
        }
        case 'SET_IS_OUT_OF_OFFICE_ENABLED': {
            return { ...state, isOutOfOfficeEnabled: action.payload };
        }
        case 'SET_IS_VALID_DATE': {
            return { ...state, isValidDate: action.payload };
        }
        case 'SET_IS_PAST_DATE': {
            return { ...state, isValidDate: action.payload };
        }
        case 'RESET': {
            return { ...initialState, ...action.payload };
        }
        default: {
            return state;
        }
    }
};
const OutOfOfficeAside = () => {
    const outOfOfficeAside = (0, zustandStore_1.useZustand)(state => state.aside.outOfOfficeAside);
    const { setIsOutOfOfficeAsideOpen, setNotification } = (0, zustandStore_1.useZustand)();
    const [state, dispatch] = (0, react_1.useReducer)(reducer, initialState);
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: currrentTeamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: currentUser } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getUserQuery)(),
        initialData: initialData.user,
    });
    const { data: approvers } = (0, paymentQuery_1.useGetTeamApproversQuery)({
        excludeSelf: true,
        excludeOutOfOffice: true,
        teamId: currrentTeamId?.[0] || '',
    });
    const { data: outOfOfficeSettings } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.getOooSettingsQuery)({
            userId: currentUser?.userId,
            teamId: currrentTeamId?.[0] || '',
        }),
        initialData: initialData.outOfOfficeSettings,
    });
    const isOooEnabled = outOfOfficeSettings
        ? outOfOfficeSettings[approvalsHeader_1.OOO_ENABLED] === 'true' || outOfOfficeSettings[approvalsHeader_1.OOO_ENABLED] === true
        : false;
    const isOooDisabledWithNoAvailableApprovers = () => {
        return Boolean(!isOooEnabled && approvers && approvers.length === 0);
    };
    const setUserTeamProperties = (0, teamQuery_1.useSetUserTeamProperties)();
    const isSubmitDisabled = !state.isValidDate || !state.startOnValue || !state.endOnValue || !state.selectedApproverUserId || state.isPastDate;
    const resetState = {
        isOutOfOfficeEnabled: isOooEnabled || initialState.isOutOfOfficeEnabled,
        startOnValue: outOfOfficeSettings ? (0, dayjs_1.default)(outOfOfficeSettings[approvalsHeader_1.OOO_START_DATE]) : initialState.startOnValue,
        endOnValue: outOfOfficeSettings ? (0, dayjs_1.default)(outOfOfficeSettings[approvalsHeader_1.OOO_END_DATE]) : initialState.endOnValue,
        isValidDate: true,
        isPastDate: false,
        selectedApproverUserId: outOfOfficeSettings
            ? outOfOfficeSettings[approvalsHeader_1.OOO_FORWARD_TO]
            : initialState.selectedApproverUserId,
    };
    (0, react_1.useEffect)(() => {
        dispatch({ type: 'SET_IS_OUT_OF_OFFICE_ENABLED', payload: isOooEnabled });
        dispatch({
            type: 'SET_START_ON_VALUE',
            payload: outOfOfficeSettings && outOfOfficeSettings[approvalsHeader_1.OOO_START_DATE]
                ? (0, dayjs_1.default)(outOfOfficeSettings[approvalsHeader_1.OOO_START_DATE])
                : startDate,
        });
        dispatch({
            type: 'SET_END_ON_VALUE',
            payload: outOfOfficeSettings && outOfOfficeSettings[approvalsHeader_1.OOO_END_DATE] ? (0, dayjs_1.default)(outOfOfficeSettings[approvalsHeader_1.OOO_END_DATE]) : endDate,
        });
        dispatch({
            type: 'SET_SELECTED_APPROVER_USERID',
            payload: outOfOfficeSettings ? outOfOfficeSettings[approvalsHeader_1.OOO_FORWARD_TO] : null,
        });
    }, [isOooEnabled, outOfOfficeSettings]);
    const saveOooSettings = async () => {
        try {
            StateSchema.parse({
                startOnValue: (0, dayjs_1.default)(state.startOnValue).utc().toISOString(),
                endOnValue: (0, dayjs_1.default)(state.endOnValue).utc().toISOString(),
                selectedApproverUserId: state.selectedApproverUserId,
                isOutOfOfficeEnabled: state.isOutOfOfficeEnabled,
                isValidDate: state.isValidDate,
                isPastDate: state.isPastDate,
            });
        }
        catch (error) {
            if (error instanceof zod_1.z.ZodError) {
                logger.error(error?.message);
            }
        }
        let settings = [
            { [approvalsHeader_1.OOO_ENABLED]: state.isOutOfOfficeEnabled },
            { [approvalsHeader_1.OOO_END_DATE]: state.endOnValue },
            { [approvalsHeader_1.OOO_START_DATE]: state.startOnValue },
        ];
        const selectedApprover = approvers?.find(approver => approver?.userId === state.selectedApproverUserId);
        if (selectedApprover) {
            settings = [
                ...settings,
                { [approvalsHeader_1.OOO_FORWARD_TO]: selectedApprover?.userId },
                { [approvalsHeader_1.OOO_FORWARD_TO_EMAIL]: selectedApprover.email },
                { [approvalsHeader_1.OOO_FORWARD_TO_FULL_NAME]: selectedApprover.fullName },
            ];
        }
        setUserTeamProperties.mutate({
            settings,
            teamId: currrentTeamId?.[0] || '',
        }, {
            onSuccess: async () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: lexico.trc('Success message', 'Your out of office settings have been saved.'),
                    },
                ]);
                setIsOutOfOfficeAsideOpen(false);
                await Root_1.queryClient.invalidateQueries({
                    queryKey: [query_keys_1.teamKeys.getOooSettings(currrentTeamId?.[0] || '', currentUser?.userId)],
                });
            },
            onError: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: lexico.trc('Warning message', 'There was a problem saving your out of office settings. Please try again.'),
                    },
                ]);
            },
        });
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isOooDisabledWithNoAvailableApprovers() && ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "submit-button", disabled: isSubmitDisabled, color: uiConstants_1.UI_BUTTON_PRIMARY, onClick: saveOooSettings, label: strings_1.inputStrings.SUBMIT })), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "reset-button", onClick: () => {
                    setIsOutOfOfficeAsideOpen(false);
                    dispatch({ type: 'RESET', payload: resetState });
                }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.inputStrings.CANCEL })] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "outOfOfficeAside", title: lexico.trc('Menu title', 'Out of office'), open: outOfOfficeAside.isOpen, onClose: () => {
            setIsOutOfOfficeAsideOpen(false);
            dispatch({ type: 'RESET', payload: resetState });
        }, footerButtons: footerButtons, children: (0, jsx_runtime_1.jsxs)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: [(0, jsx_runtime_1.jsx)(material_1.FormControl, { style: { padding: '10px 10px 10px 5px' }, children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { "data-testid": "ooo-switch-label", control: (0, jsx_runtime_1.jsx)(material_1.Switch, { "data-testid": "ooo-switch", color: "primary", disabled: isOooDisabledWithNoAvailableApprovers(), checked: state.isOutOfOfficeEnabled, onChange: evt => {
                                dispatch({ type: 'SET_IS_OUT_OF_OFFICE_ENABLED', payload: evt.target.checked });
                            } }), label: lexico.trc('Form input label', 'Enable out of office'), labelPlacement: "start" }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", style: { padding: '0 10px 10px', marginTop: 0 }, children: isOooDisabledWithNoAvailableApprovers()
                        ? lexico.trc('Validation message', 'At least one manager or team owner must be available to use out of office.')
                        : lexico.trc('Validation message', 'New requests will be automatically forwarded during this time frame.') }), !isOooDisabledWithNoAvailableApprovers() && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '20px',
                        paddingBottom: '10px',
                    }, children: [(0, jsx_runtime_1.jsx)(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, "data-testid": "ooo-start-date-picker", children: (0, jsx_runtime_1.jsx)(x_date_pickers_1.DatePicker, { "data-testid": "ooo-start-date-picker", label: lexico.trc('Form input label', 'Start forwarding on'), name: "ooo-start-date-picker", disablePast: true, minDate: (0, dayjs_1.default)(), value: (0, dayjs_1.default)(state.startOnValue).isValid() ? (0, dayjs_1.default)(state.startOnValue) : startDate, onChange: newValue => {
                                    if (!newValue) {
                                        return;
                                    }
                                    dispatch({ type: 'SET_START_ON_VALUE', payload: newValue });
                                }, onError: newError => {
                                    if (newError === 'disablePast') {
                                        dispatch({ type: 'SET_IS_PAST_DATE', payload: !newError });
                                    }
                                    else {
                                        dispatch({ type: 'SET_IS_VALID_DATE', payload: !newError });
                                    }
                                }, slotProps: { textField: { variant: 'outlined' } } }) }), (0, jsx_runtime_1.jsx)(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, "data-testid": "ooo-end-date-picker", children: (0, jsx_runtime_1.jsx)(x_date_pickers_1.DatePicker, { "data-testid": "ooo-end-date-picker", label: lexico.trc('Form input label', 'End forwarding on'), name: "ooo-end-date-picker", disablePast: true, minDate: endDate, value: (0, dayjs_1.default)(state.endOnValue, purchaseRequestForm_1.DATE_FORMAT, true).isValid() ? (0, dayjs_1.default)(state.endOnValue, purchaseRequestForm_1.DATE_FORMAT) : endDate, onChange: newValue => {
                                    if (!newValue) {
                                        return;
                                    }
                                    dispatch({ type: 'SET_END_ON_VALUE', payload: newValue });
                                }, onError: newError => {
                                    if (newError === 'disablePast') {
                                        dispatch({ type: 'SET_IS_PAST_DATE', payload: !newError });
                                    }
                                    else {
                                        dispatch({ type: 'SET_IS_VALID_DATE', payload: !newError });
                                    }
                                }, slotProps: { textField: { variant: 'outlined' } } }) })] })), !isOooDisabledWithNoAvailableApprovers() && ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, "data-testid": "ooo-approver-select", children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { "data-testid": "ooo-approver-select-label", children: lexico.trc('Form input label', 'Approver') }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "ooo-approver-select", value: state.selectedApproverUserId || '', onChange: event => {
                                dispatch({ type: 'SET_SELECTED_APPROVER_USERID', payload: event.target.value });
                            }, children: approvers?.map(value => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: value?.userId, children: value.fullName }, value.userId))) })] }))] }) }));
};
exports.default = OutOfOfficeAside;
